import * as React from 'react';
import { Autocomplete, TextField } from '@mui/material';

export const PublicProjectsSearch = (props) => {
    const [searchFieldValue, setSearchFieldValue] = React.useState(false);

    const handleSearch = labelOptionValue => {
        if (!labelOptionValue) return;
        props.canvasRef.current.SelectItemOnCanvas(labelOptionValue.id);
        props.canvasRef.current.FitToSelected();

    };

    return (
        <Autocomplete
            disablePortal
            color="inherit"
            id="searchBar"
            fullWidth
            onChange={(event, newValue) => {
                handleSearch(newValue);
            }}
            options={props.elements}
            getOptionLabel={(option) => option.data.name}
            sx={{ width: 300 }}
            renderOption={(props, option) => (
                <li {...props} key={option.data.id}>
                    {option.data.name}
                </li>
            )}
            renderInput={(params) => <TextField {...params} size='small' label="Search" style={{ Color: "#ffffff" }} />}
        />
    );
}